import React from 'react';
import SEO from '../components/SEO';

const Privacy: React.FC = () => {
  return (
    <div className="pt-24 pb-16">
      <SEO title="Kebijakan Privasi" description="Kebijakan privasi penggunaan XCape." />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Kebijakan Privasi</h1>
        <p className="text-slate-500 mb-8">Terakhir diperbarui: 22 Desember 2024</p>

        <h3>1. Informasi yang Kami Kumpulkan</h3>
        <p>XCape menghormati privasi Anda. Kami tidak mengumpulkan data lokasi pribadi Anda. Data kalibrasi yang Anda masukkan hanya disimpan secara lokal di perangkat Anda untuk keperluan fungsional aplikasi.</p>

        <h3>2. Penggunaan Data</h3>
        <p>Kami hanya mengumpulkan data teknis anonim (seperti model perangkat dan versi OS) untuk tujuan pemecahan masalah (debugging) dan peningkatan kompatibilitas sistem.</p>

        <h3>3. Keamanan</h3>
        <p>Aplikasi kami dirancang dengan prinsip 'Privacy First'. Tidak ada data lokasi yang dikirim ke server kami.</p>
        
        <h3>4. Perubahan Kebijakan</h3>
        <p>Kami dapat memperbarui kebijakan ini dari waktu ke waktu. Perubahan akan diberitahukan melalui aplikasi atau website ini.</p>
      </div>
    </div>
  );
};

export default Privacy;